export default String.raw`
{% assign type = include -%}

{% assign question = translations.AreYouSure -%}
{% assign confirmButtonText = translations.Yes -%}
{% assign declineButtonText = translations.No -%}

{% case type -%}
    {% when 0 -%}
        {% assign question = translations.AreYouSureOrderCancel -%}
        {% assign confirmButtonText = translations.OrderCancel -%}
        {% assign info = translations.CancelOrderInfo -%}
    {% when 1 -%}
        {% assign question = translations.AreYouSureComplaintCancel -%}
        {% assign confirmButtonText = translations.ComplaintCancel -%}
        {% assign info = translations.CancelComplaintInfo -%}
    {% when 2 -%}
        {% assign question = translations.AreYouSureReturnCancel -%}
        {% assign confirmButtonText = translations.ReturnCancel -%}
        {% assign info = translations.CancelReturnInfo -%}
    {% else -%}
        AreYouSureComplaintCancel
{% endcase -%}

<div class="message-popup-background hidden-js container-to-delete-js closable-popup-js confirmation-popup-js">
    <div class="change-data-container order-cancel">
        <div class="data-form">
			<div class="data-form__header">
                <span>
                    {{question}}
                </span>
				<button class="close-button close-js" aria-label="{{ translations.Close }}">
                    <svg aria-hidden="true" width="24" height="24" class="svgIcon"><use xlink:href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use></svg>
				</button>
			</div>
            <div class="data-form__info">
                {{info}}
            </div>
        <div class="buttons-container short">
            <button class="pure-button close-js no-js">
                {{declineButtonText}}
            </button>
            <button class="primary-action-button close-js yes-js container-reload-js closing-modal-mobile-js">
                {{confirmButtonText}}
            </button>
        </div>
    </div>
</div>
`